<template>
  <div class="table_card work_calendar__task_card">
    <div class="work_calendar__task_card--body" v-if="getSelectedTask() != ''">
      <div
        class="work_calendar__task_card--item_container"
        style="min-height: 40px; max-height: 65px;"
        :title="getSelectedTask().attributes.title">
        {{ getSelectedTask().attributes.title }}
      </div>

      <div class="work_calendar__task_card--subtitle">
        Inicio
      </div>
      <div class="work_calendar__task_card--item_container" style="width: 48%; display: inline-block;">
        {{ getSelectedTask().attributes.task_start | moment('hh:mm a') }}
      </div>
      <div class="work_calendar__task_card--item_container" style="width: 50%; display: inline-block;">
        {{ getSelectedTask().attributes.task_start | moment('DD MMM YYYY') }}
      </div>

      <div class="work_calendar__task_card--subtitle">
        Fin
      </div>
      <div class="work_calendar__task_card--item_container" style="width: 48%; display: inline-block;">
        {{ getSelectedTask().attributes.task_finish | moment('hh:mm a') }}
      </div>
      <div class="work_calendar__task_card--item_container" style="width: 50%; display: inline-block;">
        {{ getSelectedTask().attributes.task_finish | moment('DD MMM YYYY') }}
      </div>

      <div class="work_calendar__task_card--subtitle">
        Tipo
      </div>
      <div class="work_calendar__task_card--item_container">
        <span class="work_calendar__task_card--type_color" :style="'background-color: ' + colors[getSelectedTask().attributes.task_type]"></span>
        {{ getSelectedTask().attributes.task_type }}
      </div>

      <div class="work_calendar__task_card--subtitle">
        Proveedor
      </div>
      <div class="work_calendar__task_card--item_container">
        {{ getSelectedTask().attributes.provider.name }}
      </div>

      <div class="work_calendar__task_card--subtitle">
        Funcionarios
      </div>
      <div
        class="work_calendar__task_card--item_container"
        style="min-height: 40px; max-height: 65px;">
        <div
          v-for="staff in getSelectedTask().attributes.staff"
          :title="staff.name"
          class="work_calendar__task_card--staff">
          - {{ staff.name }}
        </div>
      </div>

      <div class="work_calendar__task_card--subtitle">
        Notas
      </div>
      <div
        class="work_calendar__task_card--item_container"
        style="min-height: 40px; max-height: 65px;"
        :title="getSelectedTask().attributes.notes">
        {{ getSelectedTask().attributes.notes }}
      </div>

      <div class="work_calendar__task_card--subtitle">
        Soportes
      </div>
      <span
        v-if="getSelectedTask().attributes.support_files.length > 0"
        @click="viewSupportFiles()"
        style="color: #1476FB; cursor: pointer;">
        {{ `Ver soportes (${getSelectedTask().attributes.support_files.length})` }}
      </span>
      <span v-else>
        No hay soportes cargados
      </span>
    </div>

    <div class="work_calendar__task_card--footer" v-if="getSelectedTask() != ''">
      <span style="padding: 10px; color: #1476FB; cursor: pointer;" @click="$emit('open-modal')">
        Editar
      </span>

      <button
        class="work_calendar__task_card--complete_task_btn"
        :style="isTheTaskCompleted ? 'background-color: #10ad05' : 'background-color: red'"
        @click="$emit('check-task')">
        {{ isTheTaskCompleted ? 'Ejecutado' : 'Ejecutar' }}

        <span
          class="work_calendar__task_card--complete_task_btn_icon material-icons"
          :style="isTheTaskCompleted ? 'color: white' : 'background-color: white'">
          {{ isTheTaskCompleted ? 'done' : '' }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'

export default {
  components: {
    VueTimepicker
  },
  props: ['task', 'colors', 'task_types'],
  data(){
    return {
      support_files_zip: ''
    }
  },
  methods: {
    viewSupportFiles(){
      this.getSelectedTask().attributes.support_files.forEach(f => {
        open(f.support_file.url)
      })
    }
  },
  computed: {
    isTheTaskCompleted(){
      return this.getSelectedTask().attributes.state == 'COMPLETED'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/work_calendar/TaskInfoCard.vue